import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import { setUser, UserRole } from "../../app/userSlice";
import { setSharedAlert } from "../../app/siteSlice";
import { AlertLevel } from "../../components/AlertMessage";
import { useGetSelfMutation } from "../users/usersApiSlice";
import { useLazySignInAsStudentQuery, useLazySignInAsTeacherQuery } from "./impersonationApiSlice";

export default function Impersonation() {
	const { role, isTeachersWriterAccount, course } = useAppSelector((state) => state.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [signInAsStudent] = useLazySignInAsStudentQuery();
	const [signInAsTeacher] = useLazySignInAsTeacherQuery();
	const [callGetSelf] = useGetSelfMutation();

	useEffect(() => {
		if (role === UserRole.Proctor) {
			signInAsStudent()
				.unwrap()
				.then(() => {
					handleSuccess();
				})
				.catch((error) => {
					handleError(error);
				});
		}
		if (role === UserRole.Writer && isTeachersWriterAccount) {
			signInAsTeacher()
				.unwrap()
				.then(() => {
					handleSuccess();
				})
				.catch((error) => {
					handleError(error);
				});
		}
	}, []);

	function handleSuccess() {
		callGetSelf()
			.unwrap()
			.then((payload) => {
				dispatch(setUser({ ...payload }));
				course ? navigate("/home") : navigate("/courses");
			})
			.catch((error: any) => {
				console.log(error);
			});
	}

	function handleError(error: any) {
		let message = "There was an error trying to impersonate.";
		if (error.data.errorCreatingStudentAccount) {
			message = "There was an error creating the student account.";
		} else if (error.data.errorImpersonatingStudent) {
			message = "There was an error logging into the student account.";
		} else if (error.data.errorLoggingIntoTeacherAccount) {
			message = "There was an error logging into the teacher account.";
		}
		dispatch(
			setSharedAlert({
				level: AlertLevel.Error,
				message: message,
				showIcon: true,
			})
		);
		course ? navigate("/home") : navigate("/courses");
	}

	return null;
}
